// Types
import { TStoreAddress } from "../../types";
import { TTimezone } from "../types";

const TIMEZONES: TTimezone[] = Intl.supportedValuesOf("timeZone").map((timezone) => ({ name: timezone }));

const MILLISECONDS = 1000;

const INITIAL_STORE_ADDRESS: TStoreAddress = {
	address: "",
	address2: "",
	city: "",
	state: "",
	zipCode: "",
	country: "",
	countryCode: "",
	timezone: "",
};

export { TIMEZONES, MILLISECONDS, INITIAL_STORE_ADDRESS };
